import Vue from 'vue'
import App from './App'
import router from './router'
import store from './store'
import Vant from 'vant';
import { Toast } from 'vant';
import { Rate } from 'vant';
import { Switch } from 'vant';
import { Button } from 'vant';
import { Area } from 'vant';
import { Swiper } from 'swiper';
import 'swiper/dist/css/swiper.min.css';
import 'vant/lib/vant-css/index.css';
import './assets/iconfont/iconfont.css';		// 引入上面下载得到的使用 font-class 图标必须的 css 文件
import './assets/iconfont/iconfont.js';			// 引入上面下载得到的使用 SVG 图标必须的 js 文件
/*import 'lib-flexible';*/

Vue.use(Area);
Vue.use(Rate);
Vue.use(Vant);
Vue.use(Switch);
Vue.use(Button);

Vue.config.productionTip = false;

router.beforeEach((to, from, next) => {
	if (to.matched.some(record => record.meta.wechatAuth) || to.matched.some(record => record.meta.policeAuth)) {
		let url = window.location.href;
		let redirectUrl = url.substring(0, url.lastIndexOf('/')) + to.path + '?from=auth';

		wechat.onReady({
			redirectUrl: redirectUrl,
			callback: function (openId) {
				if(wechat.getUserId() && wechat.getPoliceToken()) {
					$.ajaxSetup({
						dataType: "json",
						cache: false,
						headers: {
							"userId": wechat.getUserId(),
							"policeToken": wechat.getPoliceToken()
						},
						xhrFields: {
							withCredentials: true
						},
						complete: function(xhr) {
							//token过期，则跳转到登录页面
							if(xhr.responseJSON && xhr.responseJSON.code == '403') {
								wechat.showPoliceAuth();
							}
						}
					});
				}

				if(!wechat.getUserId() && to.matched.some(record => record.meta.policeAuth)) {
					wechat.showPoliceAuth();
					return;
				}

				next();
			}
		});

		return;
	}

	next();
});

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    template: '<App/>',
    components: { App }
})


// WEBPACK FOOTER //
// ./src/main.js